import { Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import CloseIcon from '@material-ui/icons/Close'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import CircularProgress from '@material-ui/core/CircularProgress'

import { ActivityIndidicator } from '../../components/CircularProgres/CircularProgress'
import MaterialUI from '../MaterialUI'
import './CustomModal.css'

function CustomModal(props) {
  const { formatMessage: trans } = useIntl()
  const {
    show,
    size,
    variant = 'default',
    customTittleText,
    customMessageModal,
    children,
    isLoading = false,
    showSuccessButton = false,
    onHandleClose,
    onHandleSuccess,
    cancelText,
    successText,
    actionsFooterStyle,
    allowClose,
    hideFooter,
    hideCloseButton,
  } = props

  const hasChildren = Boolean(children)
  const isDanger = variant === 'danger'
  const canDismiss = !isLoading && (allowClose !== undefined ? allowClose : !isDanger)
  const hasFooterActions = !isLoading || !!showSuccessButton
  const showFooter = (hideFooter !== undefined ? !hideFooter : !hasChildren) && hasFooterActions

  const handleHide = () => {
    if (canDismiss && onHandleClose) {
      onHandleClose()
    }
  }

  const SuccessButton = isDanger ? MaterialUI.Button.Danger : MaterialUI.Button.Primary
  const isSingleAction = !showSuccessButton
  const DismissButton = isSingleAction ? MaterialUI.Button.Primary : MaterialUI.Button.Secondary
  const dismissButtonVariant = isSingleAction ? 'contained' : 'outlined'

  return (
    <Modal
      className={`t4i-modal t4i-modal--${variant}`}
      size={size || undefined}
      show={!!show}
      onHide={handleHide}
      backdrop={canDismiss ? true : 'static'}
      keyboard={canDismiss}
      aria-labelledby="t4i-modal-title"
      centered
    >
      {!!customTittleText && (
        <Modal.Header className="t4i-modal__header">
          <Modal.Title id="t4i-modal-title" className="t4i-modal__title">
            {isDanger && <ErrorOutlineIcon className="t4i-modal__title-icon" fontSize="small" />}
            {customTittleText}
          </Modal.Title>
          {!hideCloseButton && canDismiss && (
            <button type="button" className="t4i-modal__close" onClick={onHandleClose} aria-label={trans({ id: 'close', defaultMessage: 'Close' })}>
              <CloseIcon fontSize="small" />
            </button>
          )}
        </Modal.Header>
      )}
      <Modal.Body className="t4i-modal__body">
        {hasChildren && <div className="t4i-modal__children">{children}</div>}
        {!!customMessageModal && !hasChildren && (
          <p className="t4i-modal__message render-with-lines">
            {customMessageModal.split('\n').map((line, index) => (
              <span key={index} className={index === 0 ? 't4i-modal__message-lead' : 't4i-modal__message-hint'}>
                {line}
              </span>
            ))}
          </p>
        )}
        {!!isLoading && <ActivityIndidicator minimal={hasChildren} showMessage={!hasChildren && !customMessageModal} />}
      </Modal.Body>
      {showFooter && (
        <Modal.Footer className={`t4i-modal__footer${actionsFooterStyle ? ' action_styles' : ''}`}>
          {!isLoading && (
            <DismissButton className="t4i-modal__dismiss" variant={dismissButtonVariant} onClick={onHandleClose}>
              {cancelText || trans({ id: 'close', defaultMessage: 'Close' })}
            </DismissButton>
          )}
          {!!showSuccessButton && (
            <SuccessButton onClick={onHandleSuccess} disabled={isLoading}>
              {isLoading && <CircularProgress size={16} color="inherit" className="me-2" />}
              {successText || trans({ id: 'accept', defaultMessage: 'Accept' })}
            </SuccessButton>
          )}
        </Modal.Footer>
      )}
    </Modal>
  )
}

export { CustomModal }
